import {
    iconRequest,
    iconClient,
    iconCalculator,
    iconAffiliate,
    iconConcessionaire,
    iconReports,
    iconReportsDefault,
    iconSearch,
    iconCertificate,
    iconPerson,
    iconZonification,
    iconUsers,
    iconParameters,
    iconDocs,
    iconNeighborhood,
    iconMassiveConsult,
} from '../defaultValues';

const data = {
    role_6f11b11a817c4ce0a50af24aa5a0dfc0: [
        {
            id: 'gogo',
            icon: iconRequest,
            label: 'Solicitudes',
            to: '/app/credits',
        },
        {
            id: 'searcRequest',
            icon: iconSearch,
            label: 'Buscar Solicitud',
            to: '/app/reports/searchRequest',
        },
        {
            id: 'secondmenu',
            icon: iconClient,
            label: 'Clientes',
            to: '/app/clients',
        },

        {
            id: 'parametros',
            icon: iconParameters,
            label: 'Parámetros',
            to: '/app/calculator',
            subs: [
                {
                    id: 'concesionarios',
                    icon: iconConcessionaire,
                    label: 'Concesionarios',
                    to: '/app/concesionarios',
                },
                {
                    id: 'aliados',
                    icon: iconAffiliate,
                    label: 'Aliados',
                    to: '/app/aliados',
                },
                {
                    id: 'personas',
                    icon: iconPerson,
                    label: 'Personas',
                    to: '/app/persons',
                },
                {
                    id: 'barrios',
                    icon: iconNeighborhood,
                    label: 'Barrios',
                    to: '/app/barrios',
                },
                {
                    id: 'city',
                    icon: iconZonification,
                    label: 'Ciudad Zonificación',
                    to: '/app/ZonificationCity',
                },
                {
                    id: 'usuarios',
                    icon: iconUsers,
                    label: 'Usuarios',
                    to: '/app/usuarios',
                },
                {
                    id: 'tuberia',
                    icon: iconReportsDefault,
                    label: 'Calculadora',
                    to: '/app/reports/calculatorParams',
                },
            ],
        },
        {
            id: 'zonification',
            icon: iconZonification,
            label: 'Zonificación',
            to: '/app/zonification',
        },

        {
            id: 'blankpage',
            icon: iconReports,
            label: 'Reportes',
            to: '/app/blank-page',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Generales',
                    to: '/app/reports/reportsDisbursement',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Desempeño Equipos',
                    to: '/app/reports/teamPerformance',
                },
            ],
        },
        {
            id: 'Preaprobador-masivo',
            icon: iconMassiveConsult,
            label: 'Pre aprobador Masivo',
            to: '/app/preAprobadorMasivo/Consultas',
        },
        {
            id: 'simulador-credito',
            icon: iconCalculator,
            label: 'Simulador de Crédito',
            to: '/app/calculator',
            subs: [
                {
                    icon: iconCalculator,
                    label: 'Simulador de Créditos',
                    to: '/app/calculator',
                },
                {
                    icon: iconCalculator,
                    label: 'Calculadora R&R',
                    to: '/app/reports/calculatorRefinancing',
                },
            ],
        },
        {
            id: 'documentos',
            icon: iconDocs,
            label: 'Documentos',
            to: '/app/calculator',
            subs: [
                {
                    id: 'certificados',
                    icon: iconCertificate,
                    label: 'Certificados',
                    to: '/app/reports/peaceAndSafe',
                    subs: [
                        {
                            id: 'fng-reports',
                            icon: iconCertificate,
                            label: 'Registrar',
                            to: '/app/reports/peaceAndSafe',
                        },
                        {
                            id: 'fng-reports',
                            icon: iconCertificate,
                            label: 'Consultar',
                            to: '/app/reports/checkCertificates',
                        },
                    ],
                },
            ],
        },
    ],
};
export default data;
